import { jsx as _jsx } from "react/jsx-runtime";
import { useToken } from '@chakra-ui/react';
import Select, { components } from 'react-select';
import { Icon, MarkdownBase } from '@/components';
import { useWindowSize } from '@/hooks';
export const DropdownBase = (props) => {
    const windowSize = useWindowSize();
    const [darkBrandBlue5, darkBrandBlue10, darkBrandBlue20, darkBrandBlue40, darkBrandBlue80] = useToken('colors', [
        'darkBrandBlue.5',
        'darkBrandBlue.10',
        'darkBrandBlue.20',
        'darkBrandBlue.40',
        'darkBrandBlue.80'
    ]);
    const styles = {
        control: (styles, { menuIsOpen }) => (Object.assign(Object.assign({}, styles), { '&:focus-within': {
                borderColor: darkBrandBlue80
            }, '&:hover': {
                borderColor: darkBrandBlue40
            }, borderColor: menuIsOpen ? darkBrandBlue40 : darkBrandBlue10, borderWidth: 2, boxShadow: 'none', minHeight: '50px', padding: '5px 10px' })),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        menu: (styles) => (Object.assign(Object.assign({}, styles), { zIndex: 999 })),
        placeholder: (styles) => (Object.assign(Object.assign({}, styles), { color: darkBrandBlue20 })),
        singleValue: (styles) => (Object.assign(Object.assign({}, styles), { textOverflow: 'initial', whiteSpace: 'normal' }))
    };
    const theme = (theme) => (Object.assign(Object.assign({}, theme), { borderRadius: 8, colors: Object.assign(Object.assign({}, theme.colors), { primary: darkBrandBlue40, primary25: darkBrandBlue5, primary50: darkBrandBlue10, primary75: darkBrandBlue40 }) }));
    const DropdownIndicator = (props) => {
        const { menuIsOpen } = props.selectProps;
        return (_jsx(components.DropdownIndicator, Object.assign({}, props, { children: _jsx(Icon, { name: 'chevron-down', p: '0', sx: {
                    transform: menuIsOpen && 'rotate(180deg)',
                    transition: 'all .2s ease'
                }, type: 'solid' }) })));
    };
    const Option = (props) => (_jsx(components.Option, Object.assign({}, props, { children: _jsx(MarkdownBase, { markdown: props.label }) })));
    const SingleValue = (props) => (_jsx(components.SingleValue, Object.assign({}, props, { children: _jsx(MarkdownBase, { markdown: String(props.children) }) })));
    return (_jsx(Select, Object.assign({ className: 'dropdown-select', components: { DropdownIndicator, Option, SingleValue }, isSearchable: false, maxMenuHeight: windowSize.height - 50, styles: styles, theme: theme }, props)));
};
